import axios from 'axios'
import baseStore from '../../index'

const state = {
  eventsItems: (localStorage.getItem("eventsList")) ? JSON.parse(localStorage.getItem('eventsList')) : [],
}

const mutations = {
  UPDATE_EVENTS_LIST (state, playload) {
    state.eventsItems = playload;
    //console.log(playload);
  },
}

const actions = {
  async getEventsItems ({ commit }, token) {
    console.log('getEventsItems => offline: '+ baseStore.getters.offlineMode)
    if (baseStore.getters.offlineMode) {
      const events = JSON.parse(localStorage.getItem('eventsList'))
      commit('UPDATE_EVENTS_LIST', JSON.parse(events))
    } else {
    axios
      .get(baseStore.getters.apiPath +'events', {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          localStorage.setItem('eventsList', JSON.stringify(response.data))
          commit('UPDATE_EVENTS_LIST', response.data)
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("GET call unsuccessful :(", error);
      });
    }
  },
}

const getters = {
  eventsItems: (state) => state.eventsItems,
  eventsItemFromId: (state) => (id) => {
    //console.log("eventsItemFromId - id: "+ id);
    return state.eventsItems.find((eventsItem) => eventsItem.id === Number(id))
  },
  eventsItemsFromFair: (state) => (fairId) => {
    //console.log("eventsItemFromFair - fairId: "+ fairId);
    return state.eventsItems.filter((eventsItem) => eventsItem.fairId === fairId)
  },
  eventsItemsFromDate: (state) => (fairId, dayId) => {
    //console.log("eventsItemFromDate - fairId: "+ fairId +" - dayId: "+ dayId);
    let allItems = state.eventsItems.filter((eventsItem) => eventsItem.fairId === Number(fairId))
    let eventsItems = [];
    allItems.forEach(function(event) {
      if (!event.items) return true
      let dateItems = event.items.filter(eventItem => eventItem.dayId === Number(dayId));
      if (dateItems) {
				//console.log(dateItems);
        let eventItem = Object.create(event)
        eventItem.items = [];
				dateItems.forEach(function(dateItem) {
					eventItem.items.push(dateItem);
				})
				if (eventItem.items.length) eventsItems.push(eventItem);
      }
    })
    //console.log(eventsItems);
    return eventsItems
  },
  eventsItemsFromType: (state) => (fairId, type) => {
    //console.log("eventsItemFromType - type: "+ type);
    let allItems = state.eventsItems.filter((eventsItem) => eventsItem.fairId === Number(fairId))
    let eventsItems = allItems.filter((eventsItem) => eventsItem.type === type)
    //console.log(eventsItems);
    return eventsItems
  },
}

const eventsModule = {
  state,
  mutations,
  actions,
  getters,
}

export default eventsModule
